import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { AdminPanelSettings } from "@mui/icons-material";
import { Posts } from "../../components/post";
import { RankingCard } from "./rankingCard";
import { DesafiosBar } from "../desafios/desafiosBar";
import { apiGetComunidade } from "../../services/apiGetComunidade";
import { useErrorStore } from "../../store/useErrorStore";
import { Loader } from "../../components/ui/Loader";
import { returnEnvironment } from "../../utils";
import { creatorIsAdmin, isAdminOfClient } from "../../utils/adminManager";
import { WIZARD_COMMUNITY_ID } from "../../constants/wizard";

export const Comunidade = () => {
    const [isLoading, setIsLoading] = useState(null);
    const [comunidade, setComunidade] = useState(null);

    const showError = useErrorStore((state) => state.showError);
    const isWizard = returnEnvironment() === "wizard";

    const fetchData = async () => {
        try {
            setIsLoading(true);
            if (WIZARD_COMMUNITY_ID) {
                const data = await apiGetComunidade(WIZARD_COMMUNITY_ID);
                setComunidade(data);
            }
        } catch (error) {
            console.log("error", error);
            showError(error);
            setComunidade(null);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const effect = async () => {
            await fetchData();
        };
        effect();
    }, []);

    if (isLoading) return <Loader />;

    return (
        <Box sx={{ padding: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                {!isWizard && <Typography variant="h4">{comunidade?.titulo}</Typography>}
                {creatorIsAdmin() && isAdminOfClient(comunidade?.cliente) && (
                    <Box sx={{ marginLeft: "auto" }}>
                        <Tooltip title="Administrar Comunidade">
                            <IconButton color="primary" component={Link} to={`/comunidade/${WIZARD_COMMUNITY_ID}/gerenciar`}>
                                <AdminPanelSettings />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}
            </Box>

            <DesafiosBar comunidade={comunidade} />
            <RankingCard comunidade={comunidade} />
            <Posts comunidade={comunidade} />
        </Box>
    );
};
